import path from 'path'

export default {
    name: "sideBar",
    computed: {
        list() {
            // console.log('this.$store.getters.leftMenu', this.$store.getters.leftMenu)
            return this.$store.getters.leftMenu
        },
        basePath() {
            return this.$store.getters.basePath
        },
        activeMenu() {
            const route = this.$route
            const {path} = route
            let menu = ''
            let obj = route.matched.find(item => {
                return !!item.meta.activeMenu
            })
            if (obj) {
                menu = obj.meta.activeMenu
            } else {
                menu = path
            }
            if (route.matched.length >= 3) {
                let data = {
                    route: route,
                    type: 'add',
                }
                this.$store.dispatch('navTab/setNavTab', data)
            }
            return menu
        },
    },
    methods: {
        resolvePath: function (rootPath) {
            return path.resolve(this.basePath, rootPath)
        },
        handleMenuSelect: function (index, indexPath) {
            let nameArr = index.split('/')
            let name = nameArr[nameArr.length - 1]
            let subName = nameArr[nameArr.length - 2]
            let oneName = nameArr[nameArr.length - 3]
            let menuId = ''
            if (nameArr.length == 4) {
                let menuObj = this.list.find((item, index) => {
                    return item.name == subName
                })
                let subObj = menuObj.children.find((item, index) => {
                    return item.name == name
                })
                menuId = subObj['menuId']
            } else if(nameArr.length == 5){
                let subObj = this.list.find((item, index) => {
                    return item.name == oneName
                })
                let menuObj = subObj.children.find((item, index) => {
                    return item.name == subName
                })
                let obj = menuObj.children.find((item, index) => {
                    return item.name == name
                })
                menuId = obj['menuId']
            } else {
                let menuObj = this.list.find((item, index) => {
                    return item.name == name
                })
                menuId = menuObj['menuId']
            }
            if (this.activeMenu == index) {
                this.contentReload()
                let params = {
                    menuId: menuId,
                    referer: document.domain,
                }
                if(params.menuId){
                    api.addOverviewSystemLoginLogs(params).then(res => {
                    })
                }

                this.$router.push({
                    path: index
                })
            } else {
                let data = {
                    route: this.$route,
                    type: 'add',
                }
                this.$store.dispatch('navTab/setNavTab', data)
                    .then(res => {
                        this.$router.push({
                            path: index,
                        })
                    })
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/layout/sideBar/sideBar.js